export default "__VITE_ASSET__twyg77At__"